export default __webpack_public_path__ + "static/media/pantry1-afterH-1440w.fee62df9.webp";